import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const SiteIdContainer = styled.div`
  display: flex;
  align-items: center;
`;
